/* eslint-disable */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type MeetingAttendee = {
  user: string;
  userType: string;
};

export type Meeting = {
  _id: string;
  title: string;
  description?: string;
  attendees: MeetingAttendee[];
  scheduledDate: string;
  duration: number;
  meetingPlatform?: string;
  projectId?: string;
  agenda?: string;
  meetingLink?: string;
  isRecurring?: boolean;
  createdBy?: string;
  org?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type MeetingsPayload = {
  title: string;
  description?: string;
  attendees: MeetingAttendee[];
  scheduledDate: string;
  duration: number;
  meetingPlatform?: string;
  projectId?: string;
  agenda?: string;
  meetingLink?: string;
  isRecurring?: boolean;
};

export type MeetingsResponse = {
  success: boolean;
  message: string;
  data: Meeting;
};

export type SaveMeetingVars = MeetingsPayload & {
  meetingId?: string;
};

const saveMeeting = async (
  vars: SaveMeetingVars
): Promise<MeetingsResponse> => {
  const { meetingId, ...payload } = vars;

  const { data } = await customAxios.put<MeetingsResponse>(
    `/meetings/${meetingId}`,
    payload
  );
  return data;
};

export const useSaveMeeting = () => {
  const queryClient = useQueryClient();

  return useMutation<MeetingsResponse, AxiosError, SaveMeetingVars>({
    mutationFn: saveMeeting,
    onSuccess: async (data, variables) => {
      const isUpdate = !!variables?.meetingId;
      // showNotification({
      //   title: "Success",
      //   message: "",
      //   color: "green",
      // });

      await queryClient.invalidateQueries(["meetings"]);

      if (isUpdate && variables?.meetingId) {
        await queryClient.invalidateQueries(["meeting", variables.meetingId]);
      }
    },
    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to save meeting",
        color: "red",
      }),
  });
};
